import React from "react"
import Work from "./work" 
import substhumb from "../images/substhumb.jpg"
import tvingthumb from "../images/tvingthumb.jpg" 
import neulthumb from "../images/neulthumb.jpg" 


import "./works.scss"

const Works = () => (
    <>
        <section id="home_container">
            <div className="work">
                <Work 
                    category="Case Study" 
                    title="SUBSKEEP" 
                    summary="6 weeklong team design project. Use design to make new feature app product based on ux process."
                    src={substhumb}
                />
                
            </div>

            <div className="work">
            <Work 
                category="Web Design" 
                title="NEULCATTE" 
                summary="8 weeklong team develop project. Mainly contributed in UI design and Front develop work"
                src={neulthumb}
            />
            </div>
            
            <div className="work">
            <Work 
                category="Case Study" 
                title="TVING" 
                summary="4 weeklong personal project. Analyze existing app and re-constructing app structure based on research. "
                src={tvingthumb}
            />
            </div>
            
            
        </section>
    </>
)
export default Works;